// get product data
const product = JSON.parse(document.querySelector(".productV9JSON").textContent);
let activeVariant = JSON.parse(document.querySelector(".variantV9JSON").textContent);

/**************
 Product Swiper
 **************/
    // setup product swiper
let productSwiper = null;

function initSwiper() {
    // re-init will replace the productSwiper
    productSwiper = new Swiper(document.querySelector(".productV9VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        zoom: {
            maxRatio: 2,
            toggle: false
        },
        navigation: {
            nextEl: '.productV9VisualSwiper .swiper-button-next',
            prevEl: '.productV9VisualSwiper .swiper-button-prev',
        },
    });

    // slide change
    productSwiper.on('slideChange', function () {
        // update the thumbnail active class
        document.querySelectorAll(".productV9VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
        document.querySelectorAll(`.productV9VisualThumbsSlide[data-index="${productSwiper.activeIndex + 1}"]`).forEach(el => el.classList.add("active"));

        // pause all videos
        document.querySelectorAll(".productV9VisualSwiperSlide video").forEach(element => {
            element.pause();
        });
    });

    // play video on slide play click
    document.querySelectorAll(".productV9VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV9VisualSwiperSlide").querySelector("video");

            // remove play button if it hasn't already been removed
            this.querySelector(".productV9VisualSwiperSlidePlay")?.remove();

            if (video) {
                // show controls
                video.controls = true;

                // play video
                video.play();
            }
        });
    });

    // custom single-click zoom
    document.querySelectorAll('.productV9VisualVariant .swiper-zoom-container')?.forEach(slide => {
        slide.addEventListener("click", () => productSwiper.zoom.toggle());
    })

    // change slide on thumbnail click
    document.querySelectorAll(".productV9VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // mobile thumbnail swiper
    const thumbnailSwiper = new Swiper(document.querySelector(".productV9VisualThumbs .swiper"), {
        slidesPerView: 'auto',
        navigation: {
            nextEl: '.productV9VisualThumbs .swiper-button-next',
            prevEl: '.productV9VisualThumbs .swiper-button-prev',
        },
    });

    // mobile active add
    document.querySelectorAll(".productV9VisualThumbsSlide.swiper-slide").forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('.productV9VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
            this.classList.add('active');
        });
    });
}

// check for variant galleries
const variantGalleries = !!document.querySelector('.productV9VisualSwiper');

// initialize the swiper if there is a variant gallery
if (variantGalleries) {
    initSwiper();
}

// main product swiper
const mainSwiper = new Swiper(document.querySelector(".productV9VisualMainSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    zoom: {
        maxRatio: 2,
        toggle: false
    },
    navigation: {
        nextEl: '.productV9VisualMainSwiper .swiper-button-next',
        prevEl: '.productV9VisualMainSwiper .swiper-button-prev',
    },
});

// slide change
mainSwiper.on('slideChange', function () {
    // update the thumbnail active class
    document.querySelectorAll(".productV9VisualMain .productV9VisualThumbsSlide.active").forEach(el => el.classList.remove("active"));
    document.querySelectorAll(`.productV9VisualMain .productV9VisualThumbsSlide[data-index="${mainSwiper.activeIndex + 1}"]`).forEach(el => el.classList.add("active"));

    // pause all videos
    document.querySelectorAll(".productV9VisualSwiperSlide video").forEach(element => {
        element.pause();
    });
});

// play video on slide play click
document.querySelectorAll(".productV9VisualMain .productV9VisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productV9VisualMain .productV9VisualSwiperSlide").querySelector("video");

        // remove play button if it hasn't already been removed
        this.querySelector(".productV9VisualMain .productV9VisualSwiperSlidePlay")?.remove();

        if (video) {
            // show controls
            video.controls = true;

            // play video
            video.play();
        }
    });
});

// custom single-click zoom
document.querySelectorAll('.productV9VisualMain .swiper-zoom-container')?.forEach(slide => {
    slide.addEventListener("click", () => mainSwiper.zoom.toggle());
})

// change slide on thumbnail click
document.querySelectorAll(".productV9VisualMain .productV9VisualThumbsSlide").forEach(element => {
    element.addEventListener("click", function () {
        // change slide
        mainSwiper.slideTo(this.dataset.index - 1);
    });
});

// mobile thumbnail swiper
const mainThumbnailSwiper = new Swiper(document.querySelector(".productV9VisualMainSwiperThumbs .swiper"), {
    slidesPerView: 'auto',
    // loop: true,
    navigation: {
        nextEl: '.productV9VisualMainSwiperThumbs .swiper-button-next',
        prevEl: '.productV9VisualMainSwiperThumbs .swiper-button-prev',
    },
});

// mobile active add
document.querySelectorAll(".productV9VisualThumbsSlide.swiper-slide").forEach(element => {
    element.addEventListener("click", function () {
        document.querySelector('.productV9VisualThumbsSlide.swiper-slide.active')?.classList.remove('active');
        this.classList.add('active');
    });
});

// View all button swaps to main images
if (document.querySelector('.productV9Gallery')) {
    document.querySelector('.productV9Gallery').addEventListener("click", () => {
        document.querySelector('.productV9Visual').classList.add('mainVisual');
    })
}

// clicking an already selected color will show variant gallery again
// only apply if variant galleries
if (variantGalleries) {
    document.querySelectorAll('.productV9OptionItemValuesLabel').forEach(element => {
        element.addEventListener("click", function () {
            document.querySelector('.productV9Visual').classList.remove('mainVisual');
        })
    })
}

/**************
 Product Quantity
 ***************/

// update quantity inputs on buttons
document.querySelector('.productV9FormQuantity').addEventListener("click", function (e) {
    const target = e.target.closest('.productV9FormQuantityButton');
    if (target) {
        let quantity = document.querySelector(".productV9FormQuantityInput").value;
        if (target.classList.contains('productV9FormQuantityButtonLess') && quantity > 1) {
            quantity--
        } else if (target.classList.contains('productV9FormQuantityButtonMore')) {
            quantity++
        }
        // update both form hidden inputs
        document.querySelector(".productV9FormQuantityInput").value = quantity;
        document.querySelector(".productV9BottomQuantityInput").value = quantity;
        // update the display
        document.querySelector(".productV9FormQuantityNumberDisplay").textContent = String(quantity);
    }
})

// update quantity on sticky bar input
document.querySelector(".productV9BottomQuantityInput")?.addEventListener("input", function () {
    document.querySelector(".productV9FormQuantityInput").value = this.value;
    document.querySelector(".productV9FormQuantityNumberDisplay").textContent = String(this.value);
});

/**************
 Product Variants
 ***************/

// variable for the product form element
const productFormATC = document.querySelector(".productV9FormATC");

// update active variant on input changes
document.querySelectorAll(".productV9OptionItemValuesLabel").forEach(function (element) {
    element.addEventListener("input", function () {

        //update bottom ATC to match top
        const value = element.querySelector('input').value;
        const name = element.querySelector('input').name;
        document.querySelector(`.productV9BottomRight select[name="${name}"]`).value = value;

        updateBottomVariant();
        updateUnavailableOptions();
        updateProduct().catch(e => console.error(e));
    });
})

// update active variant
async function updateProduct() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV9OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    if (options.length !== 0) {
        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(options)
        });
    }

    // check if variant wasn't found
    if (activeVariant === null || activeVariant === undefined) {

        // try to find new size
        const foundNewSize = nextAvailableSize();

        // fall back if no sizes available
        if (!foundNewSize) {
            productFormATC.classList.add("disabled");
            productFormATC.textContent = "Not Available";
        }
        // return no matter what
        return;
    }

    // update variant
    document.querySelector('.productV9FormVariant').value = activeVariant.id;

    // update color title if available
    if (document.querySelector('.productV9OptionItemValues.color') && document.querySelector('.productV9OptionItemLabelTitle')) {
        document.querySelector('.productV9OptionItemLabelTitle').textContent = document.querySelector('.productV9OptionItemValues.color .productV9OptionItemValuesLabelInput:checked').value;
    }

    // update price
    document.querySelector(".productV9PriceReal").textContent = price(activeVariant.price);
    if (activeVariant.compare_at_price > activeVariant.price) {
        document.querySelector(".productV9PriceReal").classList.add("sale");
        document.querySelector(".productV9PriceCompare").textContent = price(activeVariant.compare_at_price);
        document.querySelector(".productV9PriceSavings").textContent = `Save ${Math.round((activeVariant.compare_at_price - activeVariant.price) * 100 / activeVariant.compare_at_price)}%`;
    } else {
        document.querySelector(".productV9PriceReal").classList.remove("sale");
        document.querySelector(".productV9PriceCompare").textContent = "";
        document.querySelector(".productV9PriceSavings").textContent = "";
    }

    // check if the variant is in stock
    if (activeVariant.available) {
        productFormATC.classList.remove("disabled");
        productFormATC.textContent = "Add To Cart";
    } else {
        // for multi-option products (e.g. color + size), try to find an available size
        if (product.options.length > 1) {
            const foundNewSize = nextAvailableSize();
            if (foundNewSize) {
                return;
            }
        }
        productFormATC.classList.add("disabled");
        productFormATC.textContent = "Sold Out";
    }

    // update pre-order message
    preOrderUpdate(activeVariant.id)

    try {
        // update afterpay variant
        afterpay_current_variant = activeVariant;

        // update display price
        const afterpayElement = document.querySelector('[data-mpid="muscle-mat.myshopify.com"]');
        if (afterpayElement) afterpayElement.dataset.amount = activeVariant.price / 100;
    } catch (e) {
        console.error("Error updating afterpay pricing")
    }

    try {
        // if page with has variant gallery, update and show the variant specific images
        if (variantGalleries) {
            let path = window.location.pathname;
            const response = await fetch(`${path}${path.includes('?') ? "&" : "?"}variant=${activeVariant.id}&sections=main-product-v9`)
            if (response.ok) {
                const data = await response.json();
                const content = data["main-product-v9"]
                // create a new element and parse out contents
                const contentDiv = document.createElement('div');
                contentDiv.innerHTML = content;
                const newSwiper = contentDiv.querySelector('.productV9VisualVariant').innerHTML;
                // destroy old swiper and update with new media
                if (newSwiper) {
                    await productSwiper.destroy(true, true);
                    document.querySelector('.productV9VisualVariant').innerHTML = contentDiv.querySelector('.productV9VisualVariant').innerHTML;
                    // run the event listeners
                    initSwiper();
                    // show the variant swiper
                    document.querySelector('.productV9Visual').classList.remove('mainVisual');
                }
            }
        } else {
            // no special selector, try to find variant image
            if (activeVariant.featured_image) {
                // change active slide
                mainSwiper.slideTo(activeVariant.featured_image.position - 1);
            }
        }
    } catch (e) {
        console.warn("Variant image unable to update");
        console.error(e);
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// update pre-order message
function preOrderUpdate(id) {
    if (preOrder[id]?.message) {
        document.querySelector('.productV9PreOrder').textContent = preOrder[id].message;
        // dynamic buy button takes time to update
        setTimeout(() => {
            document.querySelector('.shopify-payment-button').style.display = "none";
            productFormATC.textContent = "Pre-Order Now";
        }, 500);
    } else {
        document.querySelector('.productV9PreOrder').textContent = "";
        document.querySelector('.shopify-payment-button').style.display = "block";
    }
}

// update on load
preOrderUpdate(activeVariant.id);

// update main visual with variant link
if (window.location.href.includes("variant=") && document.querySelector('.productV9VisualSwiper')) {
    document.querySelector('.productV9Visual').classList.remove('mainVisual');
}

// update color title if available on load
if (document.querySelector('.productV9OptionItemValues.color') && document.querySelector('.productV9OptionItemLabelTitle')) {
    document.querySelector('.productV9OptionItemLabelTitle').textContent = document.querySelector('.productV9OptionItemValues.color .productV9OptionItemValuesLabelInput:checked').value;
}

/*
 * Disable size options that are not available for the selected color
 */
function updateUnavailableOptions() {
    // if the product option has Colour and Size
    if (product.options.length !== 2) {
        return;
    }

    // make sure the 1st option is color
    if (product.options[0] !== "Colour" && product.options[0] !== "Color") {
        return;
    }

    // make sure the 2nd option is size
    if (product.options[1] !== "Size") {
        return;
    }

    // collect options from inputs
    const options = [];
    document.querySelectorAll(`.productV9OptionItemValuesLabelInput:checked`).forEach(element => {
        options.push(element.value);
    });

    // get the current selected color and size
    const selectedColor = options[0];
    const selectedSize = options[1];

    // loop over ever size input
    document.querySelectorAll('.productV9OptionItem[data-value="Size"] .productV9OptionItemValuesLabelInput').forEach(sizeInput => {
        // skip if this is the selected size since we don't want to disable an option that is selected
        if (sizeInput.value === selectedSize) return;

        // get the size value in the loop
        const sizeValue = sizeInput.value;

        // create array of options BUT with the current size in the loop
        const testOptions = [selectedColor, sizeValue];

        // check if a variant exists with these options
        const testVariant = product.variants.find((variant) => {
            return JSON.stringify(variant.options) === JSON.stringify(testOptions)
        });

        // if the variant doesn't exist or isn't available, disable the size option
        sizeInput.disabled = testVariant === null || testVariant === undefined || !testVariant.available;
    });
}

// update on load
updateUnavailableOptions();

// find an available size
function nextAvailableSize() {

    // ensure product has two options, behavior on only size is disruptive
    if (product.options.length !== 2) {
        return;
    }

    // get all size inputs
    const sizeInputs = document.querySelectorAll('.productV9OptionItem[data-value="Size"] .productV9OptionItemValuesLabelInput');

    for (let input of sizeInputs) {
        // if one is not disabled or selected, activate
        if (!input.disabled && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('input', {bubbles: true}));
            return true;
        }
    }
    // none found
    return false;
}

/**************
 Product ATC
 ***************/

document.querySelector(".productV9Form").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV9FormATC").classList.add("loading");

    const formData = new FormData(this);

    // if pre-order, update properties item
    if (preOrder[activeVariant.id]?.message) {
        formData.delete("properties");
        formData.set("properties[Pre-Order]", preOrder[activeVariant.id].message);
    }

    // add product
    const addedProduct = await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    document.querySelector(".productV9FormATC").classList.remove("loading");

    // open cart
    await openCart(addedProduct);
});

/**************
 Video section
 ***************/

if (document.querySelector(".productV9VideosSwiper")) {
    // set up the swiper
    new Swiper(document.querySelector(".productV9VideosSwiper"), {
        slidesPerView: 2.6,
        spaceBetween: 8,
        on: {
            slideChange: stopAllVideos
        }
    });

    // pause all videos and remove active state from all buttons
    function stopAllVideos() {
        document.querySelectorAll(".productV9VideosSwiperSlideVideo").forEach(video => {
            video.pause();
        });
        document.querySelectorAll(".productV9VideosSwiperSlideButton.active").forEach(btn => {
            btn.classList.remove("active");
        });
    }

    // delegated click handler — play the video for the clicked button
    document.querySelector('.productV9VideosSwiper').addEventListener('click', async function (e) {
        const button = e.target.closest('.productV9VideosSwiperSlideButton');
        if (!button) return;

        const slide = button.closest('.productV9VideosSwiperSlide');
        const video = slide.querySelector('.productV9VideosSwiperSlideVideo');
        if (!video) return;

        // if the video is playing, pause
        if (button.classList.contains('active')) {
            video.pause();
            button.classList.remove('active');
            return;
        }

        // stop any currently playing video before starting the new one
        stopAllVideos();

        await video.play();
        button.classList.add('active');
    });

    // remove active class from the button when its video finishes
    document.querySelectorAll('.productV9VideosSwiperSlideVideo').forEach(video => {
        video.addEventListener('ended', function () {
            this.closest('.productV9VideosSwiperSlide').querySelector('.productV9VideosSwiperSlideButton')?.classList.remove('active');
        });
    });
}

/**************
 Product Bottom
 ***************/

// show on scroll
let isVisible = false;
const productBottom = document.querySelector('.productV9Bottom');

// listen if the original ATC button is scrolled off screen
window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const buttonOffsetTop = productFormATC.offsetTop;

    if (scrollTop > buttonOffsetTop && !isVisible) {
        productBottom.classList.add('active');
        isVisible = true;
    } else if (scrollTop <= buttonOffsetTop && isVisible) {
        productBottom.classList.remove('active');
        isVisible = false;
    }
})

// update active variant on input changes
document.querySelectorAll(".productV9BottomOptionItem").forEach(function (el) {
    el.addEventListener("change", function () {
        // update top selection to match  bottom
        const value = el.value;
        document.querySelector(`.productV9OptionItemValuesLabel [value="${value}"]`).click();
        updateBottomVariant();
    });
})

// initial variant
let bottomVariant = activeVariant;

// currency
let bottomCurrency = document.querySelector('.productV9BottomPrice').textContent.split(" ")[1];

// update active variant
function updateBottomVariant() {
    // collect options from inputs
    let options = [];
    document.querySelectorAll(`.productV9BottomOptionItem`).forEach(select => {
        options.push(select.value);
    });

    // find new variant based on the options
    bottomVariant = product.variants.find((variant) => {
        return JSON.stringify(variant.options) === JSON.stringify(options)
    });

    // check if variant wasn't found
    if (bottomVariant === null || bottomVariant === undefined) {
        document.querySelector(".productV9BottomATC").classList.add("disabled");
        document.querySelector(".productV9BottomATC").textContent = "Not Available";
        return;
    }

    // update variant
    document.querySelector('.productV9BottomVariant').value = bottomVariant.id;

    // update price
    document.querySelector(".productV9BottomPrice").textContent = price(bottomVariant.price) + ` ${bottomCurrency}`;

    // check if the variant is in stock
    if (bottomVariant.available) {
        document.querySelector(".productV9BottomATC").classList.remove("disabled")
        document.querySelector(".productV9BottomATC").textContent = "Add To Cart";
    } else {
        document.querySelector(".productV9BottomATC").classList.add("disabled");
        document.querySelector(".productV9BottomATC").textContent = "Sold Out";
    }
}

// match variant on load
updateBottomVariant();

/**************
 Product ATC
 ***************/

document.querySelector(".productV9BottomRight").addEventListener("submit", async function (e) {
    e.preventDefault();

    // add loading animation
    document.querySelector(".productV9BottomATC").classList.add("loading");

    const formData = new FormData(this);

    // if pre-order, update properties item
    if (preOrder[activeVariant.id]?.message) {
        formData.delete("properties");
        formData.set("properties[Pre-Order]", preOrder[activeVariant.id].message);
    }

    // add product
    const addedProduct = await addProduct(formData);

    // remove loading animation
    document.querySelector(".productV9BottomATC").classList.remove("loading");

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // open cart
    await openCart(addedProduct);
});